module.exports = __webpack_public_path__ + "img/flash-1.345a1d35.svg";